export const publishableKey = 'pk_test_51GzNu6Elr9XPrX6yzZPXmwFcFWJzPgytq5969CVj5v6wnQi3knWAAouf9ukU3MOi33cwuf84rRHKaxzuPOTjHsqo00WgtHd6Xp';